<template>
  <div id="car">
    <van-tabs color="#887BFF" v-model="active" @click="car_type">
      <van-tab :title="$t('column.car')" name="shop">
        <van-row class="car_shop">
          <van-col span="12" v-for="(l,i) in list" :key="l.id + '_' + i" class="car_type">
            <van-col span="24" class="car_div">
              <div class="car_play" @click="car_play(l.img)">{{ $t('column.preview') }}</div>
              <van-col span="24" class="car_img">
                <van-image width="100" height="100" :src="l.title_img"/>
              </van-col>
              <van-col span="24" class="car_name">{{ l.name }}</van-col>
              <van-col span="24" class="car_sum">{{ l.coin }} <img :src="consumer_price_Icon"/>/{{ l.day }} {{ $t('other.days') }}</van-col>
              <van-col span="20" offset="2" class="car_btn" @click="car_btn(l.id)">{{ $t('btn.purchase')}}</van-col>
            </van-col>
          </van-col>
        </van-row>
      </van-tab>
      <van-tab :title="$t('column.mycar')" name="my_car">
        <van-row class="car_shop">
          <van-col span="12" v-for="(l) in user_list" :key="l.id" class="car_type">
            <van-col span="24" class="car_div">
              <van-col span="24" class="car_name my_car_name">{{ l.name }}</van-col>
              <van-col span="24" class="car_img my_car_img">
                <van-image width="100" height="100" :src="l.title_img"/>
              </van-col>
              <van-col span="24" class="my_car_sum">{{ $t('column.due_date') }}：</van-col>
              <van-col span="24" class="my_car_sum">{{ l.endtime }}</van-col>
              <van-col span="20" offset="2" class="car_btn" @click="my_car_btn(l.id)">
                {{ my_car_status === l.carid ? $t('other.close') : $t('other.open') }}
              </van-col>
            </van-col>
          </van-col>
        </van-row>
      </van-tab>
    </van-tabs>

    <van-overlay :show="svgaShow" @click.native="svgaHide">
        <div id="svgaBox" @click.stop="svgaHide"></div>
    </van-overlay>
  </div>
</template>

<script>

    import '@/assets/css/style.css'
    import axios from 'axios'
    import Toast from "vant/lib/toast"
    import {Dialog} from 'vant'
    import SVGA from "svgaplayerweb"

    export default {
        data() {
            return {
                svgaShow: false,
                active: 0,
                list: [],
                user_list: [],
                my_car_status: '',
                user: [],
                diamonds_name: '',
                consumer_price_Icon: '',
            }
        },
        created: function () {
            this.convert();
            document.title = this.$t('title.shop')
        },
        components: {
            [Dialog.name]: Dialog
        },
        mounted() {
            // 将要给原生调用的方法挂载到 window 上面
            window.get_open_native = this.get_open_native
            window.GetPayCallbackStatus = this.GetPayCallbackStatus
        },
        methods: {
          svgaHide() {
            this.svgaShow = false
          },
            convert: function () {
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vehicle&act=index").then(res => {
                    console.log(res.data)
                    this.list = res.data.list
                    this.diamonds_name = res.data.diamonds_name
                    this.consumer_price_Icon = res.data.consumer_price_Icon
                })
            },
            car_type(name, title) {
                if (name === 'shop') {
                    this.convert()
                } else {
                    this.my_car()
                }
            },
            my_car: function () {
                const uid = this.$route.query.uid
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vehicle&act=my_car", {
                    params: {
                        uid: uid,
                        token: token
                    }
                }).then(res => {
                    console.log(res.data)
                    this.user_list = res.data.car
                    if (res.data.status === 0) {
                        Toast(res.data.error)
                        return false
                    } else {
                        this.user = res.data.user_info
                        this.my_car_status = this.user.noble_car_id
                    }
                })
            },
            car_btn(id) {
                const uid = this.$route.query.uid
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vehicle&act=select_coin", {
                    params: {
                        user_id: uid,
                        token: token,
                        id: id
                    }
                }).then(res => {
                    if (res.data.status === 1) {
                        this.pay_car(res.data.list.car_type, res.data.list.id, res.data.list.nobleid, res.data.list.time)
                    } else {
                        Toast(res.data.error)
                    }
                })
            },
            pay_car(car_type, id, nobleid, time) {
                const name = car_type ? time + this.$t('other.expire') + '<br/>' + this.$t('Tips.car_renewal') : this.$t('Tips.Do_you_want_to_buy_car')
                Dialog.confirm({
                    title: this.$t('Tips.buying_a_car'),
                    message: name,
                  confirmButtonText: this.$t('btn.confirm'),
                  cancelButtonText: this.$t('btn.cancel'),
                }).then(() => {
                    const uid = this.$route.query.uid
                    const token = this.$route.query.token
                    axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vehicle&act=pay", {
                        params: {
                            user_id: uid,
                            token: token,
                            id: id,
                            car_id: nobleid
                        }
                    }).then(res => {
                        console.log(res.data)
                        Toast(res.data.error)
                        if (res.data.status === 1) {
                            this.convert()
                        }
                    })
                }).catch(() => {
                })
            },
            my_car_btn(id) {
                const uid = this.$route.query.uid
                const token = this.$route.query.token
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=vehicle&act=car_open_close", {
                    params: {
                        user_id: uid,
                        token: token,
                        id: id
                    }
                }).then(res => {
                    console.log(res.data)
                    if (res.data.status === 1) {
                        this.my_car()
                    } else {
                        Toast(res.data.error)
                    }
                })
            },
            car_play(url) {
              this.svgaShow = true
              const _this= this
              this.$nextTick(() => {
                try {
                  const player = new SVGA.Player('#svgaBox');
                  const parser = new SVGA.Parser('#svgaBox');
                  //注意，这里必须是服务器地址，否则报错
                  parser.load(url, function(videoItem) {
                    player.loops = 1;  // 设置循环播放次数是1
                    player.setVideoItem(videoItem);
                    player.startAnimation();
                    player.onFinished(function(){
                      _this.svgaShow = false
                    });
                  })
                } catch (error) {
                  console.error(error);
                }
              })
              //  window.location.href = "live://open_native?svgaurl=" + url
            }
        }
    }
</script>

<style>
#svgaBox { height: 100vh;}
</style>



// WEBPACK FOOTER //
// src/components/car.vue